// extracted by mini-css-extract-plugin
export default {"ConteneurInfo":"Ajouter_ConteneurInfo__Z5U1H","Formulaire":"Ajouter_Formulaire__EBor3","btsSty":"Ajouter_btsSty__3yC8i","fore":"Ajouter_fore__lF8TU"};